module.exports = __webpack_public_path__ + "img/14.327c6ee3.png";